module.exports = __webpack_public_path__ + "img/image-014.f6ea8a2e.png";